import { IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class RmLevelIdRequest {
    @ApiProperty()
    @IsOptional()
    levelId?: number;
}

